import React from 'react'
import IconMinusCircle from '../../../assets/icons/icon-minus-circle.svg'
import AlertTriangleIcon from '../../../assets/icons/icon-alert-triangle.svg'
import LockProgressSvg from '../../../assets/icons/icon-lock-progress.svg'
import {
  LevelIndicatorDot,
  LevelCompleteIcon,
  LevelInProgressIcon,
  LevelWarningIcon,
  LevelLockIcon
} from './Styles/ProgressTracker.styles'

const LevelIndicator = ({ completed, active, locked, hasIncompleteRequirements, suspended }) => {
  if (suspended) {
    return <LevelWarningIcon src={AlertTriangleIcon} alt="Suspended" />
  }
  if (hasIncompleteRequirements) {
    return <LevelWarningIcon src={IconMinusCircle} alt="" />
  }
  if (completed) {
    return <LevelCompleteIcon />
  }
  if (locked) {
    return <LevelLockIcon src={LockProgressSvg} alt="Locked" />
  }
  if (active) {
    return <LevelInProgressIcon />
  }
  return <LevelIndicatorDot />
}

export default LevelIndicator

